import * as React from "react"

const IconDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M3.5319 13.25C3.5319 13.4489 3.61091 13.6397 3.75157 13.7803C3.89222 13.921 4.08299 14 4.2819 14L11.7819 14C11.9808 14 12.1716 13.921 12.3122 13.7803C12.4529 13.6397 12.5319 13.4489 12.5319 13.25C12.5319 13.0511 12.4529 12.8603 12.3122 12.7197C12.1716 12.579 11.9808 12.5 11.7819 12.5L4.2819 12.5C4.08299 12.5 3.89222 12.579 3.75157 12.7197C3.61091 12.8603 3.5319 13.0511 3.5319 13.25ZM3.84315 6L5.0319 6L5.0319 3C5.0319 2.73478 5.13726 2.48043 5.32479 2.29289C5.51233 2.10536 5.76668 2 6.0319 2L10.0319 2C10.2971 2 10.5515 2.10536 10.739 2.29289C10.9265 2.48043 11.0319 2.73478 11.0319 3L11.0319 6L12.1882 6C12.3362 6.00013 12.481 6.0441 12.6041 6.12636C12.7273 6.20863 12.8233 6.3255 12.8801 6.46226C12.9369 6.59902 12.952 6.74953 12.9234 6.89484C12.8948 7.04014 12.8238 7.17372 12.7194 7.27875L8.7394 11.2875C8.64649 11.3809 8.53604 11.4549 8.41441 11.5055C8.29278 11.556 8.16236 11.582 8.03065 11.582C7.89894 11.582 7.76852 11.556 7.64689 11.5055C7.52526 11.4549 7.41481 11.3809 7.32189 11.2875L3.3119 7.2775C3.20792 7.17241 3.13733 7.03893 3.10897 6.89384C3.08062 6.74875 3.09577 6.59852 3.15254 6.46202C3.2093 6.32551 3.30514 6.20883 3.42802 6.12663C3.55089 6.04443 3.69532 6.00037 3.84315 6Z"
      fill="#4F4FFF"
    />
  </svg>
)

export default IconDownload
